document.addEventListener("turbo:load", toggleFundingAgencyRadio);
document.addEventListener("DOMContentLoaded", toggleFundingAgencyRadio);

function toggleFundingAgencyRadio() {
  var radios = document.querySelectorAll('.form-switch-toggle input[type="radio"][name="funding_agency[is_public]"]');
  if (!radios.length) return;
  radios.forEach(function(radio) {
    radio.addEventListener('change', function() {
      radios.forEach(function(r) {
        var btn = r.parentElement.querySelector('.toggle-btn');
        if (btn) btn.classList.remove('active');
      });
      var btn = radio.parentElement.querySelector('.toggle-btn');
      if (radio.checked && btn) btn.classList.add('active');
    });
    // Inicializa o estado correto ao carregar
    var btn = radio.parentElement.querySelector('.toggle-btn');
    if (radio.checked && btn) btn.classList.add('active');
    else if (btn) btn.classList.remove('active');
  });
}
